/**
 * Gestion des messages FR des pages
 */

module.exports = {

    auth: {
        login: {
            title: 'Connexion'
        },
        register: {
            title: 'Inscription'
        },
        forgotPassword: {
            title: 'Mot de passe oublié'
        },
        resetPassword: {
            title: 'Réinitialisation du mot de passe'
        },
        initPassword: {
            title: 'Initialisation de votre mot de passe'
        }
    },

    privacyPolicy: {
        title: 'Politique de confidentialité',
        browserNotCompatible: 'Votre navigateur ne peut pas afficher le fichier.',
        buttons: {
            downloadPdf: {
                label: 'Télécharger le fichier',
                altLabel: 'Télécharger le fichier PDF de la politique de confidentialité.'
            }
        }
    },

    home: {
        title: 'Bonjour { user }',
        description: 'Bienvenue sur votre tableau de bord.',
        createPublication: {
            button: {
                label: 'Ajouter une publication'
            }
        },
        return: {
            planned: 'La tâche { task } a été planifiée pour le traitement de votre retour.',
            validated: 'La tâche { task } a été validée.',
            publicationWaiting: 'La tâche { task } a été programmée pour être publiée.',
            completed: 'Vous avez complété la tâche { task } avec succès.',
            published: 'La tâche { task } a été publiée.'
        }
    },

    me: {
        account: {
            title: 'Mon compte',
            description: 'Visualiser et modifier les informations de votre compte.',
            statistics: {
                title: 'Statistiques',
                description: 'Visualiser vos statistiques.',
                empty: 'Aucun compte n\'a été trouvé.',
                period: 'Du { dateStart } au { dateEnd }',
                account: {
                    empty: 'Aucune donnée pour cette période.',
                    statistics: {
                        followers: {
                            facebook: 'fan de la page | fan de la page | fans de la page',
                            instagram: 'follower | follower | followers',
                            linkedin:  'follower | follower | followers',
                            twitter: 'follower | follower | followers',
                        }
                    }
                },
                publications: {
                    empty: 'Aucune donnée pour cette période.',
                    panels: {
                        best: {
                            title: 'Top posts'
                        },
                        thematics: {
                            title: 'Thématiques',
                            sections: {
                                best: 'Thématiques les plus performantes',
                                worst: 'Thématiques les moins performantes'
                            }
                        },
                        schedule: {
                            title: 'Détails par créneaux horaires'
                        },
                        graphicalLineTemplates: {
                            title: 'Chartes graphiques',
                            empty: 'Aucune donnée disponible.'
                        },
                        tones: {
                            title: 'Tons les plus performants',
                            empty: 'Aucune donnée disponible.'
                        },
                        analysis: {
                            title: 'Analyse des publications',
                            sections: {
                                numericalAnalysis: {
                                    title: 'Analyse numérique'
                                },
                                semanticAnalysis: {
                                    title: 'Analyse sémantique'
                                },
                                writingModel: {
                                    title: 'Modèle d\'écriture'
                                }
                            },
                            positivePoints: 'Points positifs',
                            negativePoints: 'Points négatifs'
                        },
                        recommendations: {
                            title: 'Recommandations',
                            sections: {
                                thematics: {
                                    title: 'Thématiques',
                                    replacement: 'Remplacer la thématique "{ oldThematic }" par la thématique "{ newThematic }".'
                                },
                                editorialStyle: {
                                    title: 'Style éditorial'
                                },
                                hours: {
                                    title: 'Horaires'
                                }
                            }
                        }
                    },
                    statistics: {
                        actions: 'Nombre d\'interactions : { value }',
                        views: 'Nombre de vues : { value }',
                        uniqueViews: '0 vue unique | 1 vue unique | { value } vues uniques',
                        engagement: 'Engagement : { value }'
                    },
                    sort: {
                        label: 'Tri',
                        actions: 'Nombre d\'intéractions',
                        views: 'Nombre de vues',
                        engagement: 'Taux d\'engagement'
                    },
                    list: {
                        task: {
                            consult: 'Consulter la publication'
                        }
                    }
                }
            },
            bills: {
                list: {
                    title: 'Mes factures',
                    empty: 'Aucune facture n\'a été trouvée.',
                    table: {
                        fields: {
                            date: 'Date',
                            name: 'Numéro de facture',
                            amount: 'Montant',
                            file: 'Facture',
                            status: 'Statut'
                        },
                        file: {
                            download: {
                                altLabel: 'Télécharger la facture { name }.'
                            }
                        },
                        status: {
                            payed: 'Facture réglée',
                            toPay: 'Facture à régler'
                        }
                    }
                }
            },
            socialNetworks: {
                button: {
                    unlink: {
                        network: {
                            altLabel: 'Délier le réseau { network } de  votre compte.',
                            confirmation: {
                                message: 'Êtes-vous sûr de vouloir délier { network } de votre compte ? Si vous avez des publications programmées, elles ne pourront pas être publiées pour ce réseau.',
                                error: 'Une erreur s\'est produite pendant la dé-liaison du compte.'
                            }
                        },
                        informations: {
                            label: 'Comment délier { applicationName } de ses réseaux sociaux ?'
                        }
                    }
                }
            },
            aiPostImageList: {
                empty: 'Aucune image n\'a été trouvée.',
                title: 'Images',
                addImagesButton: {
                    label: 'Ajouter des images'
                }
            },
            cancelTrialPeriod: {
                button: {
                    label: 'Annuler la période d\'essai'
                },
                confirmationModal: {
                    message: 'Êtes-vous sûr de vouloir annuler votre période d\'essai. En annulant votre période d\'essai, vous continuerez à accéder à ses fonctionnalités jusqu\'au { date }. Au delà, vous devrez souscrire à un abonnement.',
                    error: 'Une erreur s\'est produite pendant l\'annulation de votre période d\'essai.'
                }
            },
            removeAccount: {
                button: {
                    label: 'Supprimer le compte',
                    altLabel: 'Démarrer la procédure de suppression de votre compte.'
                },
                confirmationModal: {
                    message: 'Nous sommes navrés d\'apprendre que vous nous quittez déjà. La qualité du service est une priorité, pouvons-nous vous aider dans l\'utilisation de la solution ? Un conseiller peut prendre contact avec vous.',
                    contact: {
                        informations: {
                            title: 'Confirmation de vos informations',
                            about: 'Veuillez confirmer les informations suivantes pour que nous puissions vous contacter.',
                            success: 'Votre demande a été envoyée avec succès.',

                            form: {
                                error: 'Une erreur s\'est produite pendant l\'envoi de votre demande.',
                                fields: {
                                    firstName: 'Prénom',
                                    lastName: 'Nom',
                                    email: 'Adresse email',
                                    phone: 'Numéro de téléphone',
                                    societyName: 'Société'
                                }
                            }
                        },
                    },
                    remove: {
                        message: 'L\'ensemble des données seront supprimées, vous n\'aurez plus accès à vos plannings et les autorisations d\'accès à votre réseaux sociaux seront rompues.',
                        error: 'Une erreur s\'est produite pendant la suppression de votre compte.',
                        buttons: {
                            confirm: {
                                label: 'Je confirme la suppression'
                            }
                        }
                    },
                    buttons: {
                        contact: {
                            label: 'Oui, contactez-moi',
                            altLabel: 'Demander à être contacté par un conseillé.'
                        },
                        remove: {
                            label: 'Je supprime mon compte',
                            altLabel: 'Confirmer la suppression du compte.'
                        }
                    }
                }
            },
            writingStyles: {
                title: 'Style rédactionnel'
            },
            identityVisual: {
                title: 'Identité visuelle'
            },
            postsSettings: {
                title: 'Personnalisation des posts'
            },
            repositoryFiles: {
                title: 'Mes fichiers',
                description: 'Gérer les fichiers à utiliser pour générer vos publications.',
                empty: 'Aucun fichier n\'a été trouvé',
                add: {
                    button: {
                        label: 'Ajouter un fichier'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Éditer le fichier { name }.'
                    }
                },
                remove: {
                    button: {
                        altLabel: 'Supprimer le fichier { name }.',
                    },
                    confirmationModal: {
                        message: 'Êtes-vous sûr de vouloir supprimer le fichier { name } ?',
                        error: 'Une erreur s\'est produite pendant la suppression du fichier.',
                    }
                },
                table: {
                    fields: {
                        name: 'Nom du fichier',
                        date: 'Date d\'ajout',
                        size: 'Taille',
                        status: 'Statut',
                        actions: 'Actions'

                    },
                    status: {
                        waiting: 'En attente',
                        inProgress: 'En cours de traitement',
                        failed: 'Échec',
                        ready: 'Prêt'
                    }
                }
            }
        },
        requestedHolidays: {
            requestButton: {
                label: 'Faire une demande'
            },
            internal: {
                title: 'Demandes de congés',
                description: 'Visualiser vos demandes de congés.'
            },
            external: {
                title: 'Demandes d\'absences',
                description: 'Visualiser vos demandes d\'absences.'
            },
            list: {
                empty: 'Aucune demande n\'a été trouvé',
                fields: {
                    type: 'Type',
                    period: 'Période',
                    duration: 'Durée',
                    status: 'Statut'
                }
            },
            time: '1 jour | { count } jours',
            delete: {
                modal: {
                    message: 'Êtes-vous sûr de vouloir annuler votre demande pour la période du { begin } au { end } ?',
                    error: 'Une erreur s\'est produite pendant la suppression de votre demande.'
                }
            }
        },
        ai: {
            planning: {
                subjects: {
                    validation: {
                        title: 'Validation de vos sujets de publication',
                        loadingError: 'Une erreur s\'est produite pendant le chargement de vos sujets de publication.'
                    }
                }
            }
        },
        task: {
            // Gestion de tâche par un manager
            managing: {
                list: {
                    title: 'Tableau de réalisation des tâches',
                    description: 'Visualiser votre tableau de réalisation des tâches et votre historique de tâches.',
                    empty: 'Aucune tâche n\'a été trouvée',
                    errorAgents: 'Une erreur s\'est produite pendant le chargement des agents.'
                }
            },
            // Tâches d'un agent
            running: {
                list: {
                    title: 'Tableau de réalisation de tâches',
                    description: 'Visualiser votre tableau de réalisation des tâches et votre historique de tâches.',

                    incoming: {
                        loading: {
                            error: 'Une erreur s\'est produite pendant le chargement des tâches à venir.'
                        }
                    },

                    processing: {
                        complete: '{ customer } a été notifié que la tâche { task } attend un retour de sa part.'
                    }
                }
            },
            write: {
                title: 'Rédaction d\'une publication',
                loadingError: 'Une erreur s\'est produite pendant le chargement de la tâche.'
            },
            return: {
                loadingError: 'Une erreur s\'est produite pendant le chargement de la tâche.',
                title: '{ task } - Effectuer un retour'
            },
            list: {
                customer: {
                    title: 'Posts',
                    description: 'Visualiser, créer, éditer et valider.',
                    empty: 'Aucune tâche n\'a été trouvée',

                    byMonth: {
                        title: 'Planning éditorial',
                        countCurrentIdeasGeneration: 'post exécuté | post exécuté | posts exécutés'
                    },

                    subjectsIdeas: {
                        empty: 'Les premiers sujets de votre veille apparaîtront dans quelques instants. N\'hésitez pas à revenir voir régulièrement.',
                        addSourceButton: {
                            label: 'Ajouter une source de veille'
                        },
                        goToSubscriptionPageButton: {
                            label: 'Abonnez-vous pour voir la suite'
                        }
                    }
                }
            },
            validation: {
                waiting: {
                    title: 'Publications en attente de validation',
                    errorLoadTasks: 'Une erreur s\'est produite pendant le chargement des publications.',
                    empty: 'Vous n\'avez aucun post à vérifier.'
                }
            },
            edit: {
                customer: {
                    title: 'Edition de la tâche { task }',
                    loadingError: 'Une erreur s\'est produite pendant le chargement de la tâche.',
                    preview: {
                        title: 'Aperçu du post'
                    },
                    taskType: {
                        changeError: 'Une erreur s\'est produite pendant le changement du type de tâche.',
                        type: {
                            image: 'Post simple',
                            carousel: 'Carrousel',
                            album: 'Album',
                            video: 'Vidéo'
                        }
                    },
                    taskNetworks: {
                        title: 'Publier sur...',
                        addAccountButton: {
                            label: 'Connecter un profil'
                        },
                        accountsModal: {
                            label: 'Connecter un profil'
                        },
                        tiktokSettings: {
                            title: 'Paramètres de vidéo TikTok',
                            error: 'Une erreur s\'est produite pendant l\'enregistrement.',
                            privacy: {
                                label: 'Mode de la vidéo',
                                options: {
                                    private: 'Privé',
                                    friends: 'Entre amis',
                                    public: 'Public'
                                }
                            },
                            comments: {
                                label: 'La vidéo peut recevoir des commentaires ?',
                                options: {
                                    yes: 'Oui',
                                    no: 'Non'
                                }
                            },
                            duets: {
                                label: 'Fonctions Duos',
                                options: {
                                    private: 'Moi uniquement',
                                    friends: 'Entre amis',
                                    public: 'Tout le monde'
                                },
                                tooltips: {
                                    private: 'Moi uniquement : si tu choisis cette autorisation, les autres utilisateurs ne peuvent pas réaliser de Duos avec tes vidéos.',
                                    friends: 'Amis (les followers que tu suis en retour) : si tu choisis cette autorisation et que tu as activé les Duos, seules les personnes qui te suivent et que tu suis en retour peuvent réaliser des Duos avec tes vidéos.',
                                    public: 'Tout le monde : si tu choisis cette autorisation et que tu as activé les Duos, tout le monde peut réaliser des Duos avec tes vidéos.'
                                }
                            },
                            stitch: {
                                label: 'Fonction Collage',
                                options: {
                                    private: 'Moi uniquement',
                                    friends: 'Entre amis',
                                    public: 'Tout le monde'
                                },
                                tooltips: {
                                    private: 'Moi uniquement : si tu choisis cette autorisation, les autres utilisateurs ne peuvent pas réaliser de Collages avec tes vidéos.',
                                    friends: 'Amis (les followers que tu suis en retour) : si tu choisis cette autorisation et que tu as activé les Collages, seules les personnes qui te suivent et que tu suis en retour peuvent réaliser des Collages avec tes vidéos.',
                                    public: 'Tout le monde : si tu choisis cette autorisation et que tu as activé les Collages, tout le monde peut réaliser des Collages avec tes vidéos.'
                                }
                            }
                        }
                    },
                    hook: {
                        title: 'Texte de la publication',
                        promptPanel: {
                            textarea: {
                                placeholder: 'Instruction pour améliorer votre légende... Demandez une légende plus courte ou plus longue, sur un autre ton, s\'adressant à telle cible, intégrant des puces, précisant un sujet ou intégrant un sujet'
                            },
                            errors: {
                                prompt: 'Une erreur s\'est produite pendant le traitement de votre demande.'
                            }
                        },
                        promptHistorical: {
                            title: 'Historique des prompts',
                            prompt: {
                                date: 'Le { day } à { time } : ',
                                subtitle: 'Instructions données à l\'IA : '
                            }
                        }
                    },
                    media: {
                        title: 'Média',
                        description: {
                            image: 'Éditez le visuel de votre post directement dans l\'éditeur graphique',
                            video: 'Uploadez une vidéo'
                        },
                        edit: {
                            button: {
                                label: 'Éditer le visuel dans l\'éditeur graphique',
                                labelReduced: 'Éditer le visuel'
                            }
                        },
                        uploadVideo: {
                            button: {
                                label: 'Uploader une vidéo'
                            },
                            specifications: {
                                facebook: {
                                    format: 'Format : 16:9 (paysage), 9:16 (portrait)',
                                    dimensions: 'Dimensions recommandées : 1280 x 720 pixels (pour le format 16:9), 720 x 1280 pixels (pour le format 9:16)',
                                    duration: 'Durée : jusqu’à 240 minutes',
                                    types: 'Type de fichier : MP4, MOV',
                                    size: 'Taille de fichier : jusqu’à 10 Go maximum'
                                },
                                linkedin: {
                                    format: 'Format : 1:2.4, 2.4:1',
                                    dimensions: 'Dimensions recommandées : de 256 x 144 pixels à 4096 x 2304 pixels',
                                    duration: 'Durée : de 3 secondes à 10 minutes',
                                    types: 'Type de fichier : MP4, AVI, QuickTime, MOV, ASF, FLV, MPEG-1, MPEG-4, MKV, WebM',
                                    size: 'Taille de fichier : 5 Go'
                                },
                                instagram: {
                                    formatSquare: 'Carré et carrousel - 1080px x 1080px soit rapport d\'aspect 1:1',
                                    formatPortrait: 'Portrait - 1080px x 1350px soit rapport d\'aspect 4:5',
                                    formatLandscape: 'Paysage - 1080px x 608px soit rapport d\'aspect 16:9',
                                    duration: '2 min max',
                                    size: '4 GO max'
                                }
                            }
                        },
                        removeVideo: {
                            button: {
                                label: 'Supprimer la vidéo'
                            }
                        }
                    },
                    footer: {
                        validationButton: {
                            label: 'Programmer le post'
                        },
                        saveButton: {
                            label: 'Sauvegarder le post'
                        },
                        linkAccountsButton: {
                            label: 'Connecter ses réseaux pour publier'
                        }
                    }
                }
            }
        },
        publicationsComments: {
            list: {
                title: 'Gestion des commentaires',
                description: 'Gérer les commentaires de vos publications sur les réseaux sociaux.',
                filters: {
                    searching: {
                        placeholder: 'Rechercher un commentaire par titre de publication, auteur ou contenu du commentaire'
                    },
                    answered: {
                        yes: 'Répondus',
                        no: 'Non répondus'
                    }
                }
            }
        },
        agency: {
            usersMenuTab: {
                users: 'Utilisateurs',
                roles: 'Rôles'
            },
            users: {
                list: {
                    title: 'Gestion des utilisateurs de l\'agence',
                    table: {
                        fields: {
                            users: 'Utilisateurs',
                            customers: 'Clients',
                            actions: 'Actions'
                        }
                    }
                },
                removeContact: {
                    button: {
                        altLabel: 'Supprimer le compte de { user }.'
                    },
                    confirmationModal: {
                        error: 'Une erreur s\'est produite pendant la suppression du compte.',
                        title: 'Confirmer la suppression du compte de { user }'
                    }
                },
                createContact: {
                    button: {
                        label: 'Ajouter un utilisateur',
                        altLabel: 'Ajouter un compte à l\'agence.'
                    },
                    createModal: {
                        title: 'Ajout d\'un compte à l\'agence',
                    },
                    createForm: {
                        error: 'Une erreur s\'est produite pendant la création du compte.'
                    }
                },
                editContact: {
                    button: {
                        altLabel: 'Éditer le compte de { user }.'
                    },
                    editModal: {
                        title: 'Édition du compte de { user }',
                    },
                    editForm: {
                        error: 'Une erreur s\'est produite pendant la mise à jour du compte de { user }.'
                    },
                },
                manageCustomers: {
                    tabMenu: {
                        current: 'Clients actuels',
                        add: 'Ajouter un client',
                    },
                    list: {
                        empty: 'Aucun client n\'a été trouvé.',
                        modal: {
                            title: 'Gestion des clients de { user }'
                        },
                        fields: {
                            name: 'Nom',
                            email: 'Email',
                            society: 'Société'
                        }
                    },
                    remove: {
                        error: 'Use erreur s\'est produite pendant le retrait du client.',
                        modal: {
                            title: 'Retrait de { customer } du compte { user }',
                        },
                        button: {
                            altLabel: 'Supprimer le client du compte de { user }.'
                        }
                    },
                    add: {
                        error: 'Use erreur s\'est produite pendant l\'ajout du client.',
                        modal: {
                            title: 'Ajout de { customer } au compte { user }',
                        },
                        button: {
                            altLabel: 'Ajouter le client au compte de { user }.'
                        }
                    },
                    button: {
                        consult: {
                            altLabel: 'Gérer les clients de { user }.'
                        }
                    }
                }
            },
            customers: {
                list: {
                    empty: 'Aucun client n\'a été trouvé.',
                    title: 'Liste de vos clients',
                    fields: {
                        societyName: 'Nom entreprise',
                        customerEmail: 'Email client',
                        withEnabledSubscription: 'Actif',
                        agencyRemuneration: 'Rémunération de l\'agence',
                        customerPromotion: 'Promotion du client',
                        actions: 'Actions'
                    },
                    globalCounters: {
                        agencyRemuneration: 'Rémunération de l\'agence : { amount }',
                        customerPromotion: 'Promotion des clients : { amount }',
                        totalSubscriptions: 'Abonnements actifs : { count }'
                    },
                    agencyInformation: 'Tous les mois, vous recevez sur votre compte le montant cumulé de vos affiliés. Ce montant est reversé dès que vous avez atteint de 50€ mensuel d\'affiliation au minimum et sur présentation d\'une facture à en-tête de votre structure envoyée à { contactEmail }. La facture doit être envoyée dans les 90 jours.',
                    editTaskButton: {
                        altLabel: 'Éditer les tâches de { customer }.'
                    },
                    consultPublicationsCommentsButton: {
                        altLabel: 'Consulter les commentaires des publications de { customer }.'
                    },
                    editAccount: {
                        altLabel: 'Éditer le compte de { customer }.'
                    },
                    enableAccount: {
                        altLabel: 'Activer le compte.'
                    },
                    editSubscription: {
                        altLabel: 'Éditer l\'abonnement de { customer }.'
                    },
                    statistics: {
                        altLabel: 'Consulter les statistiques de { customer }.'
                    },
                    graphicalLineTemplates: {
                        altLabel: 'Consulter les modèles graphiques de { customer }.'
                    },
                    repositoryFiles: {
                        altLabel: 'Consulter les fichiers de { customer }.'
                    }
                },
                tasksList: {
                    title: 'Planning éditorial de { customer }'
                },
                editAccount: {
                    description: 'Visualiser et modifier les informations de { customer }.'
                },
                subscription: {
                    description: 'Souscrire ou modifier l\'abonnement de { customer }'
                },
                publicationsComments: {
                    title: 'Commentaires des publications de { customer }',
                    description: 'Gérer les commentaires sur les réseaux sociaux des publications de { customer }.'
                },
                statistics: {
                    title: 'Statistiques de { customer }',
                    description: 'Visualiser les statistiques de { customer }.'
                },
                writingStyles: {
                    title: 'Style rédactionnel de { customer }'
                },
                postsSettings: {
                    title: 'Personnalisation des publications de { customer }',
                },
                graphicalLineTemplates: {
                    title: 'Gestion des modèles graphiques de { customer }',
                },
                repositoryFiles: {
                    title: 'Fichiers de { customer }',
                    description: 'Gérer les fichiers à utiliser pour générer les publications de { customer }.'
                },
                visualIdentity: {
                    title: 'Identité visuelle de { customer }'
                }
            },
            bills: {
                list: {
                    title: 'Vos dernières factures'
                }
            },
            affiliationCodes: {
                list: {
                    title: 'Codes d\'affiliation',
                    empty: 'Aucun code d\'affiliation n\'a été trouvé.',
                    fields: {
                        code: 'Code d\'affiliation',
                        agencyRemuneration: 'Pourcentage de rémunération de l\'agence',
                        customerPromotion: 'Pourcentage de promotion du client',
                        actions: 'Actions'
                    }
                },
                button: {
                    add: {
                        label: 'Ajout un code'
                    },
                    edit: {
                        altLabel: 'Edition du code d\'affiliation { code }.'
                    }
                }
            }
        }
    },

    admin: {
        // Page de paramètres pour le Super Admin
        superAdmin: {
            settings: {
                title: 'Paramètres pour le Super Admin',
                description: 'Éditer l\'application en tant que Super Admin',
                buttons: {
                    aiTest: {
                        label: 'Test IA',
                        altLabel: 'Tester des prompts pour l\'IA.'
                    }
                },
            },
            aiTest: {
                title: 'Test de prompt avec les API d\'IA',
                response: {
                    timing: 'L\'API a répondu en { timing } secondes.',
                    choices: {
                        title: 'Réponse d\'OpenAI | Réponse d\'OpenAI | Réponses d\'OpenAI',
                        empty: 'Aucune réponse n\'a été retourné par l\'API d\'OpenAI.',
                        item: {
                            title: 'Choix { position }'
                        }
                    },
                    usage: '{ total } jetons ont été utilisés ({ promptTokens } pour le prompt, { completionTokens } pour la réponse).'
                },
                geminiResponse: {
                    empty: 'Aucun contenu n\'a été générée.'
                },
                '123rfResponse': {
                    empty: 'Aucune image n\'a été trouvée.'
                },
                blackForestLabsResponse: {
                    empty: 'L\'image n\'a pas pu être générée.'
                }
            },
            socialNetworks: {
                title: 'Mise à jour des jetons d\'accès des réseaux sociaux du Super Admin'
            }
        },

        // Templates des chartes graphiques
        graphicalLineTemplate: {
            list: {
                title: 'Gestion des modèles graphiques',
                description: 'Gérer les modèles graphiques à utiliser pour les publications.',
                empty: 'Aucun modèle n\'a été trouvé.',
                filters: {
                    owner: 'Mes modèles',
                    all: 'Tous les modèles',
                    type: {
                        default: 'Filtrer le type',
                        single: 'Image simple',
                        carousel: 'Carrousel'
                    },
                    thematic: {
                        placeholder: 'Thématique à filtrer'
                    }
                }
            },
            addButton: {
                label: 'Ajouter un modèle',
                altLabel: 'Ajouter un modèle graphique.'
            },
            editButton: {
                altLabel: 'Éditer le modèle graphique { name }.'
            },
            removeButton: {
                altLabel: 'Supprimer le modèle graphique { name }.'
            }
        },

        // Codes de promotion
        promotionCodes: {
            title: 'Codes de promotion',
            list: {
                empty: 'Aucun code de promotion n\'a été trouvé.',
                fields: {
                    alphaCode: 'Code'
                }
            },
            item: {
                edit: {
                    button: {
                        altLabel: 'Éditer le code de promotion { code }.'
                    }
                }
            }
        },

        // Factures
        bills: {
            title: 'Factures',
            list: {
                empty: 'Aucune facture n\'a été trouvée.',
                fields: {
                    date: 'Date',
                    name: 'Numéro de facture',
                    customer: {
                        name: 'Nom du client',
                        email: 'Email du client',
                        society: {
                            name: 'Société'
                        }
                    },
                    amount: 'Montant',
                    file: 'Facture',
                    status: 'Statut'
                },
                file: {
                    download: {
                        altLabel: 'Télécharger la facture { name }.'
                    }
                },
                filters: {
                    date: {
                        start: 'Du',
                        end: 'au'
                    }
                }
            },
        },

        // Demande de congés
        requestedHolidays: {
            list: {
                title: 'Demandes de congés',
                description: 'Visualiser, valider ou refuser les demandes de congés de vos agents.',
                empty: 'Aucune demande ne correspond à votre recherche.',
                fields: {
                    agent: {
                        code: 'Code',
                        name: 'Agent'
                    },
                    type: 'Type',
                    period: 'Période',
                    duration: 'Durée',
                    remaining: 'Restants',
                    status: 'Statut'
                },
                time: '1 jour | { count } jours',
            },
            accept: {
                button: {
                    label: 'Accepter la demande.'
                }
            },
            decline: {
                button: {
                    label: 'Refuser la demande.'
                },
                modal: {
                    title: 'Refus de la demande',
                    message: 'Précisez la raison du refus de la demande d\'absence de { name } pour la période du { start } au { end }.'
                }
            }
        },

        // Administration des crédits
        credits: {
            title: 'Gestion des crédits et des abonnements',
            list: {
                credits: {
                    loadingError: 'Une erreur s\'est produite pendant le chargement des packs de crédit.',
                    tab: {
                        credits: 'Crédits',
                        subscription: 'Abonnement',
                        statistics: 'Statistiques'
                    },
                    fields: {
                        name: 'Nom',
                        credits: 'Crédits',
                        unitPriceWithoutTax: 'Tarif H.T.'
                    },
                    title: {
                        unique: 'Tarifs des crédits',
                        monthly: 'Tarifs des abonnements'
                    }
                },
                taskConfigurations: {
                    title: 'Configurateur Tâche / Crédits',
                    fields: {
                        name: 'Tâche',
                        credits: 'Valeur en crédits',
                        time: 'Temps'
                    }
                }
            },
            edit: {
                button: {
                    altLabel: {
                        unique: 'Éditer le tarif { name }.',
                        monthly: 'Éditer l\'abonnement { name }.'
                    }
                }
            },
            taskConfiguration: {
                edit: {
                    button: {
                        altLabel: 'Éditer la configuration de la tâche { name }.'
                    }
                }
            },
            manageVisibility: {
                button: {
                    altLabel: {
                        unique: 'Gérer les segments d\'utilisateurs du tarif { name }.',
                        monthly: 'Gérer les segments d\'utilisateurs de l\'abonnement { name }.'
                    }
                }
            },
            modal: {
                credits: {
                    edit: {
                        title: {
                            unique: 'Édition d\'un tarif de crédits',
                            monthly: 'Édition d\'un abonnement'
                        }
                    },
                    manageVisibility: {
                        title: 'Configurateur de segment d\'utilisateurs'
                    }
                },
            }
        },

        taskConfigurations: {
            groups: {
                list: {
                    title: 'Groupes de configuration de tâche',
                    description: 'Gérer les groupes de configuration de tâche permettant d\'organiser les formats du formulaire de création de tâche d\'un client.',
                    empty: 'Aucun groupe n\'a été trouvé.',
                    add: {
                        button: {
                            label: 'Ajouter un groupe'
                        }
                    },
                    edit: {
                        button: {
                            altLabel: 'Édition du groupe { name }.'
                        }
                    },
                    editTaskConfigurations: {
                        button: {
                            label: 'Tâches',
                        }
                    }
                }
            }
        },

        videos: {
            tutorial: {
                menu: {
                    categories: 'Catégories',
                    questions: 'Questions',
                    videos: 'Vidéos'
                },
                list: {
                    title: 'Gestion des vidéos de tutorial',
                    description: 'Administrer les catégories, les questions et les vidéos de tutorial.'
                },
                category: {
                    list: {
                        error: 'Une erreur s\'est produite pendant le chargement de la liste des catégories.',
                        empty: 'Il n\'y a pas de catégorie.'
                    },
                    addButton: {
                        label: 'Ajouter une catégorie'
                    },
                    editButton: {
                        altLabel: 'Editer la catégorie { category }.'
                    }
                },
                question: {
                    list: {
                        error: 'Une erreur s\'est produite pendant le chargement de la liste des questions.',
                        empty: 'Il n\'y a pas de question.'
                    },
                    addButton: {
                        label: 'Ajouter une question'
                    },
                    editButton: {
                        altLabel: 'Editer la question { question }.'
                    }
                },
                video: {
                    list: {
                        error: 'Une erreur s\'est produite pendant le chargement de la liste des vidéos.',
                        empty: 'Il n\'y a pas de vidéo.'
                    },
                    addButton: {
                        label: 'Ajouter une vidéo'
                    },
                    editButton: {
                        altLabel: 'Editer la vidéo { video }.'
                    }
                }
            },
            list: {
                title: 'Gestion des vidéos',
                description: 'Administrer les vidéos proposées aux clients lors de la création d\'une publication.',
                empty: 'Aucune vidéo n\'a été trouvée.',
                loadTaskConfigurations: {
                    error: 'Une erreur s\'est produite pendant le chargement des formats.'
                },
                add: {
                    button: {
                        label: 'Ajouter une vidéo'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Modifier la vidéo { video }.'
                    }
                }
            },
            import: {
                button: {
                    label: 'Importer des vidéos'
                }
            }
        },

        publicationIdeas: {
            list: {
                title: 'Gestion des idées de publication',
                description: 'Administrer les idées de publications proposées aux clients lors de la création d\'une publication.',
                empty: 'Aucune idée de publication n\'a été trouvée.',
                loadTaskConfigurations: {
                    error: 'Une erreur s\'est produite pendant le chargement des formats.'
                },
                add: {
                    button: {
                        label: 'Ajouter une idée de publication'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Modifier l\'idée { idea }.'
                    }
                }
            },
            import: {
                button: {
                    label: 'Importer des idées de publication'
                }
            }
        },

        // Gestion du marronnier
        horseChestnut: {
            loadEvent: {
                error: 'Une erreur s\'est produite pendant le chargement de l\'événement.'
            },
            list: {
                title: 'Configurateur de marronnier',
                description: 'Visualiser et éditer vos marronniers.',
                empty: 'Aucun événement n\'a été trouvé.',
                loadResources: {
                    error: 'Une erreur s\'est produite pendant le chargement des données.'
                },
            }
        },

        // Gestion des permissions
        permissions: {
            sections: {
                list: {
                    title: 'Liste des sections de permissions',
                    description: 'Gérer l\'organisation des permissions.',
                    warning: 'Soyez très prudents lorsque vous faites des modifications ou des ajouts sur les permissions. Cela a une incidence sur les rôles.',
                    empty: 'Aucune section de permissions ne correspond à votre recherche.',
                    fields: {
                        name: 'Nom'
                    },
                    create: {
                        button: {
                            label: 'Ajouter une section',
                            altLabel: 'Configurer une nouvelle section'
                        }
                    },
                    edit: {
                        button: {
                            altLabel: 'Éditer la section { name }.'
                        }
                    }
                },
                edit: {
                    title: 'Édition de la section des permissions { name }',
                    description: 'Gérer les groupes de permissions de cette section.',
                    loadingError: 'Une erreur s\'est produite pendant le chargement des données.',
                    groups: {
                        title: 'Liste des groupes de la section { name }',
                        empty: 'Il n\'y a pas de groupe dans cette section.',
                        fields: {
                            name: 'Nom',
                            type: 'Type'
                        },
                        type: {
                            crud: 'CRUD',
                            authorization: 'Autorisation'
                        },
                        edit: {
                            button: {
                                altLabel: 'Éditer le groupe { name }.'
                            }
                        },
                        create: {
                            button: {
                                label: 'Ajouter un groupe',
                                altLabel: 'Ajouter un groupe à la section { name }.'
                            }
                        },
                        permissions: {
                            fields: {
                                name: 'Nom',
                                type: 'Type'
                            },
                            type: {
                                consult: 'Consultation',
                                create: 'Création',
                                edit: 'Édition',
                                delete: 'Suppression',
                                authorized: 'Autorisation',
                                grant: 'Accorder'
                            },
                            edit: {
                                button: {
                                    altLabel: 'Éditer la permission { name }.'
                                }
                            },
                            add: {
                                button: {
                                    label: 'Ajouter une permission',
                                    altLabel: 'Ajouter une permission au groupe { name }.'
                                }
                            }
                        }
                    }
                }
            }
        },
        // Gestion des rôles
        roles: {
            list: {
                title: 'Liste des rôles',
                description: 'Définissez les rôles à attribuer à vos utilisateurs.',
                empty: 'Aucun rôle ne correspond à votre recherche.',
                fields: {
                    name: 'Nom',
                    owner: 'Propriétaire',
                    countUsers: 'Utilisateurs'
                },
                create: {
                    button: {
                        label: 'Ajouter un rôle',
                        altLabel: 'Configurer un nouveau rôle.'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Éditer le rôle { name }.'
                    }
                }
            },
            create: {
                title: 'Création d\'un rôle',
                description: 'Définissez les permissions d\'un nouveau rôle.',
                loadingError: 'Une erreur s\'est produite pendant le chargement des permissions.'
            },
            edit: {
                title: 'Édition du rôle { name }',
                description: 'Définissez la liste des permissions des utilisateurs ayant le rôle { name }.',
                loadingError: 'Une erreur s\'est produite pendant le chargement du rôle.',
                permissions: {
                    allowed: 'Autorisé',
                    grant: 'Accorder',
                    consult: 'Consulter',
                    create: 'Créer',
                    edit: 'Éditer',
                    delete: 'Supprimer'
                }
            }
        },

        // Personnalisation de l'application
        customizeApplication: {
            title: 'Personnalisation de l\'application',
            description: 'Gérer les CGU et la politique de confidentialité de votre application.',
            loadingError: 'Une erreur s\'est produite pendant le chargement de l\'application.',
            manageGraphicalLineTemplatesButton: {
                label: 'Chartes graphiques',
                altLabel: 'Gestion des chartes graphiques.'
            }
        },

        // Gestion des mails internes
        mails: {
            title: 'Configuration des mails internes',
            description: 'Consultez ou modifiez les contenus des mails.',
            list: {
                empty: 'Aucun mail ne correspond à votre recherche.',
                fields: {
                    name: 'Nom',
                    lang: 'Langue'
                },
                item: {
                    edit: {
                        altLabel: 'Modifier le mail { name }.'
                    }
                },
                searching: {
                    placeholder: 'Initialisation, Tâche, Validation...'
                }
            }
        },

        // Gestion des contacts
        contacts: {
            title: 'Gestion de vos contacts',
            description: 'Gérer la liste des utilisateurs rattachés à votre compte.',
            list: {
                empty: 'Aucun contact ne correspond à votre recherche.',
                fields: {
                    name: 'Nom',
                    email: 'Adresse email',
                    createdAt: 'Créé le'
                },
                create: {
                    button: {
                        label: 'Ajouter un contact',
                        altLabel: 'Ajouter un contact à votre compte.'
                    }
                },
                item: {
                    impersonate: {
                        altLabel: 'Se connecter au compte de { user }.'
                    },
                    invite: {
                        altLabel: 'Inviter { name } à se connecter.'
                    },
                    edit: {
                        altLabel: 'Modifier le compte de { name }.'
                    },
                    remove: {
                        altLabel: 'Supprimer le compte de { name }.'
                    }
                }
            }
        },

        // Gestion des secteurs d'activités
        activitySectors: {
            title: 'Liste des secteurs d\'activité',
            description: 'Gérer la listes des secteurs d\'activité et de leur métiers.',
            list: {
                empty: 'Aucun secteur d\'activité ne correspond à votre recherche.',
                fields: {
                    name: 'Nom',
                    parent: 'Secteur parent'
                },
                searching: {
                    placeholder: 'Fleuriste, Boulanger, Informatique...'
                },
                edit: {
                    button: {
                        altLabel: 'Éditer le secteur d\'activité { name }.'
                    }
                },
                create: {
                    button: {
                        label: 'Ajouter un secteur',
                        altLabel: 'Ajouter un nouveau secteur.'
                    }
                },
                item: {
                    edit: {
                        altLabel: 'Modifier le secteur { name }.'
                    }
                }
            },
            create: {
                title: 'Ajout d\'un secteur d\'activité',
                description: 'Configuration d\'un nouveau secteur d\'activité.'
            },
            edit: {
                title: 'Édition du secteur d\'activité { name }',
                description: 'Modifier le secteur d\'activité { name } et gérer ses métiers.',
                loadingError: 'Une erreur s\'est produite pendant le chargement du secteur d\'activité.'
            }
        },

        // Message de désinscription
        unsubscribeMessages: {
            list: {
                title: 'Messages de désabonnement',
                description: 'Gérer les messages de désabonnement et consulter les statistiques.',
                empty: 'Aucun message de désabonnement n\'a été trouvé.',
                fields: {
                    message: 'Message',
                    enabled: 'Actif',
                    countUsed: 'Réponses'
                },
                enabledStatus: {
                    enabled: 'Oui',
                    disabled: 'Non'
                },
                create: {
                    button: {
                        label: 'Ajouter un message',
                        altLabel: 'Configurer un nouveau message de désabonnement.'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Éditer le message de désabonnement { message }.'
                    }
                }

            },
            statistics: {
                table: {
                    fields: {
                        reason: 'Raison',
                        countUsed: 'Nombre de votes'
                    }
                }
            }
        },

        // Gestion des utilisateurs
        users: {
            edit: {
                loading: 'Une erreur s\'est produite pendant le chargement de l\'utilisateur.',
                created: 'Le compte de { name } a été créé avec succès.',
                updated: 'Le compte de { name } a été mis à jour avec succès.',
                tabs: {
                    informations: 'Informations',
                    planning: 'Planning'
                }
            },
            agentStatus: {
                enable: {
                    altLabel: 'Cliquez pour activer l\'agent.'
                },
                disable: {
                    altLabel: 'Cliquez pour désactiver l\'agent.'
                }
            },
            list: {
                fields: {
                    name: 'Nom',
                    email: 'Email',
                    phone: 'Tél.',
                    code: 'Code',
                    createdAt: 'Créé le',
                    customerAgent: 'Agent associé',
                    society: 'Société',
                    activitySector: 'Secteur',
                    credits: 'Crédits',
                    networksAccounts: 'Réseaux sociaux',
                    contract: {
                        start: 'Date d\'entrée',
                        type: 'Contrat'
                    },
                    counters: {
                        agents: {
                            label: 'Agents',
                            altLabel: 'Nombre d\'agents gérés'
                        },
                        features: {
                            label: 'Fonctionnalités',
                            altLabel: 'Nombre de fonctionnalités'
                        }
                    }
                },
                loading: {
                    activitySectors: {
                        error: 'Une erreur s\'est produite pendant le chargement des secteurs d\'activité.'
                    }
                },
                item: {
                    editButton: {
                        altLabel: 'Éditer les informations de { name }.'
                    }
                }
            },
            internalAgent: {
                create: {
                    title: 'Ajouter un agent interne',
                    description: 'Créer un agent interne à l\'entreprise.'
                },
                edit: {
                    title: 'Édition de l\'agent interne { name }',
                    description: 'Éditer l\'agent interne { name }.'
                },
                list: {
                    title: 'Liste des agents internes',
                    description: 'Gérer la liste des agents internes.',
                    createUserButton: {
                        label: 'Ajouter un agent',
                        altLabel: 'Ajouter un nouvel agent interne.'
                    },
                    empty: 'Aucun agent interne ne correspond à votre recherche.',

                }
            },
            externalAgent: {
                create: {
                    title: 'Ajouter un agent externe',
                    description: 'Créer un agent externe à l\'entreprise.'
                },
                edit: {
                    title: 'Édition de l\'agent externe { name }',
                    description: 'Éditer l\'agent externe { name }.'
                },
                list: {
                    title: 'Liste des agents externes',
                    description: 'Gérer la liste des agents externes.',
                    createUserButton: {
                        label: 'Ajouter un agent',
                        altLabel: 'Ajouter un nouvel agent externe.'
                    },
                    empty: 'Aucun agent externe ne correspond à votre recherche.'
                }
            },
            teamManager: {
                create: {
                    title: 'Ajouter un manager',
                    description: 'Créer un manager qui pourra gérer son équipe.'
                },
                edit: {
                    title: 'Édition du manager { name }',
                    description: 'Éditer le manager { name }.',
                    agents: 'Liste des agents gérés par { name }'
                },
                list: {
                    title: 'Liste des managers',
                    description: 'Gérer la liste des managers.',
                    createUserButton: {
                        label: 'Ajouter un manager',
                        altLabel: 'Ajouter un nouveau manager.'
                    },
                    empty: 'Aucun manager ne correspond à votre recherche.'
                }
            },
            productManager: {
                create: {
                    title: 'Ajouter un chef de produit',
                    description: 'Créer un chef de produit qui pourra gérer les notifications et les rendez-vous client.'
                },
                edit: {
                    title: 'Édition du chef de produit { name }',
                    description: 'Éditer le chef de produit { name }.'
                },
                list: {
                    title: 'Liste des chefs de produit',
                    description: 'Gérer la liste des chefs de produit.',
                    createUserButton: {
                        label: 'Ajouter un chef de produit',
                        altLabel: 'Ajouter un nouveau chef de produit.'
                    },
                    empty: 'Aucun chef de produit ne correspond à votre recherche.'
                },
            },
            agencyManager: {
                list: {
                    title: 'Liste des managers d\'agences',
                    description: 'Gérer la liste des managers d\'agences.',
                    empty: 'Aucun chef manager d\'agence ne correspond à votre recherche.'
                },
                button: {
                    displayCustomers: {
                        altLabel: 'Consulter les clients de l\'agence { agency }.'
                    }
                }
            },
            customer: {
                create: {
                    title: 'Ajouter un client',
                    description: 'Créer un nouveau client.'
                },
                edit: {
                    title: 'Édition du client { name }',
                    description: 'Éditer le client { name }.'
                },
                list: {
                    title: 'Liste des clients',
                    description: 'Gérer la liste des clients.',
                    createUserButton: {
                        label: 'Ajouter un client',
                        altLabel: 'Ajouter un nouveau client.'
                    },
                    exportButton: {
                        label: 'Exporter les clients',
                        altLabel: 'Exporter la liste des clients au format CSV.'
                    },
                    empty: 'Aucun client ne correspond à votre recherche.',
                    searching: {
                        name: {
                            placeholder: 'Jean-Charles, Annick, Elisabeth...'
                        },
                        email: {
                            placeholder: 'Recherche par adresse email'
                        },
                        society: {
                            placeholder: 'Recherche par nom de société'
                        }
                    }
                }
            }
        },

        // Gestion des offres de coaching
        coachingOffers: {
            list: {
                title: 'Liste des offres de coaching',
                description: 'Gérer les offres de coaching',
                create: {
                    button: {
                        label: 'Ajouter une offre',
                        altLabel: 'Configurer une nouvelle offre de coaching.'
                    }
                },
                empty: 'Aucune offre de coaching ne correspond à votre recherche.',
                fields: {
                    name: 'Nom',
                    time: 'Temps',
                    credits: 'Crédits'
                },
                item: {
                    edit: {
                        altLabel: 'Éditer l\'offre { name }.'
                    },
                    delete: {
                        altLabel: 'Supprimer l\'offre { name }.'
                    }
                }
            },
            create: {
                title: 'Ajouter une offre de coaching',
                description: 'Paramétrer une nouvelle offre de coaching.'
            },
            edit: {
                title: 'Édition de l\'offre de coaching { name }',
                description: 'Éditer les paramètres de l\'offre.',
                loadingError: 'Une erreur s\'est produite pendant le chargement de l\'offre.',
                created: 'L\'offre { name } a été créée avec succès.',
                updated: 'L\'offre { name } a été mise à jour avec succès.',
            },
            remove: {
                title: 'Suppression de l\'offre de coaching { name }',
                error: 'Une erreur s\'est produite pendant la suppression de l\'offre.'
            }
        }


    },

    // Résumé des factures des clients d'une agence
    digestBills: {
        list: {
            empty: 'Aucune facture n\'a été trouvée.',
            fields: {
                date: 'Date',
                name: 'Numéro de facture',
                amount: 'Montant',
                file: 'Facture'
            },
            file: {
                download: {
                    altLabel: 'Télécharger la facture { name }.'
                }
            }
        }
    }

};
